interface CardContentProps {
  wide?: boolean;
  children: JSX.Element;
}

const CardContent = ({ wide, children }: CardContentProps) => {
  const widthClass = wide ? 'md:max-w-2xl md:px-8' : 'md:max-w-100 md:px-0';

  return (
    <div
      className={`flex flex-1 w-full px-4 py-5 md:py-12 bg-neutral-000 rounded-xl border border-neutral-300 md:border-0 md:mx-auto ${widthClass}`}
    >
      {children}
    </div>
  );
};

CardContent.defaultProps = {
  wide: false,
};

export default CardContent;
